/*
 * @Author: Teemo Ding
 * @Date: 2021-07-09 16:00:24
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 15:56:12
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Taxes/TaxEditPage/config.tsx
 */
import { replaceI18nVariables } from '@/src/tools/tools';
import React from 'react';
import css from './css.module.less';
export const breadcrumbData = (title, { getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '',
    name: title || getI18n('storeTaxes.taxListPage.addTaxRules'),
  },
];

export const countryColumns = (
  deleteFun,
  countrys,
  disableEdit,
  { getI18n },
) => [
  {
    title: getI18n('storeTaxes.taxEditPage.countryArea'),
    dataIndex: 'country',
    default: true,
    optional: true,
    key: 'country',
    className: css.columnClass,
    minWidth: 300,
    render: (text, record) => {
      const length = (
        countrys.filter((country) => country.country.code === text.code)[0]
          ?.subdivisions || []
      ).length;

      const { subdivisions = [] } = record;

      const sub =
        subdivisions && length !== (subdivisions || []).length
          ? `(${replaceI18nVariables(
              getI18n('storeTaxes.taxEditPage.provincesanalytic'),
              (subdivisions || []).length,
              length,
              (subdivisions || []).map((item) => item.name).join(','),
            )})`
          : '';
      return `${text?.name} ${sub}`;
    },
  },
  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'actions',
    default: true,
    optional: true,
    key: 'actions',
    className: css.columnClass,
    width: 126,
    childGenerate: (text, record) =>
      disableEdit ? (
        '-'
      ) : (
        <div
          className={css.delete}
          onClick={() => {
            deleteFun(record);
          }}>
          {getI18n('general.delete')}
        </div>
      ),
  },
];
